import { ClientStatus, IClient } from "intake_shared/src/types";
import { safeToDate } from "./v2utils";

const APPOINTMENT_HELD_WARNING_HOURS = 48;
const HOURS_PER_DAY = 24;
const MILLISECONDS_PER_HOUR = 60 * 60 * 1000;

export interface AppointmentHeldDuration {
    enteredAt: Date;
    hours: number;
    isOverdue: boolean;
    label: string;
}

export function getAppointmentHeldDuration(
    value: unknown,
    now = new Date()
): AppointmentHeldDuration | null {
    const enteredAt = safeToDate(value);

    if (!enteredAt || Number.isNaN(enteredAt.getTime())) {
        return null;
    }

    const elapsedMilliseconds = now.getTime() - enteredAt.getTime();
    if (elapsedMilliseconds < 0) {
        return null;
    }

    const hours = Math.floor(elapsedMilliseconds / MILLISECONDS_PER_HOUR);
    const days = Math.floor(hours / HOURS_PER_DAY);

    return {
        enteredAt,
        hours,
        isOverdue: hours >= APPOINTMENT_HELD_WARNING_HOURS,
        label:
            hours < 1
                ? "<1 hour ago"
                : hours < APPOINTMENT_HELD_WARNING_HOURS
                ? `${hours} ${hours === 1 ? "hour" : "hours"} ago`
                : `${days} ${days === 1 ? "day" : "days"} ago`,
    };
}

export function getAppointmentHeldStatusHistoryUpdate(
    client: Pick<IClient, "status" | "status_history">,
    nextStatus: ClientStatus,
    enteredAt = new Date()
): IClient["status_history"] | null {
    if (
        nextStatus !== ClientStatus.APPT_HELD ||
        client.status === ClientStatus.APPT_HELD
    ) {
        return null;
    }

    return {
        ...client.status_history,
        [ClientStatus.APPT_HELD]: enteredAt,
    };
}
